import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable } from 'rxjs';
import { PromoGamer } from 'src/app/interfaces/promo-gamer';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromoGamerService {

  apiUrl = environment.API_URL;

  constructor(private http : HttpClient) { }

 

  getPromoGamer(code: string, city?: string | null, province?: string | null, lat?: string | null, lng?: string | null): Observable<PromoGamer[]> {
    let params = new HttpParams();
    params = params.set('Code', code);

    if(city) {
      params = params.set('City', city);
    }

    if(province) {
      params = params.set('Province', province);
    }

    if(lat) {
      params = params.set('Latitude', lat);
    }

    if(lng) {
      params = params.set('Longitude', lng);
    }

    return this.http.get<any>(`${this.apiUrl}/Promo`, { params });
  }
}
